'use strict';

module.exports = require('./is-implemented')() ? Symbol : require('./polyfill');



/*****************
 ** WEBPACK FOOTER
 ** /Users/bvaughn/Documents/git/react-devtools/~/es6-symbol/index.js
 ** module id = 9
 ** module chunks = 0
 **/